import { render, staticRenderFns } from "./PaymentMethodManagement.vue?vue&type=template&id=670a5dd8&scoped=true&"
import script from "./PaymentMethodManagement.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodManagement.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodManagement.vue?vue&type=style&index=0&id=670a5dd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a5dd8",
  null
  
)

export default component.exports